import { render, staticRenderFns } from "./TournamentIndex.vue?vue&type=template&id=5c7e2326&scoped=true"
import script from "./TournamentIndex.vue?vue&type=script&lang=js"
export * from "./TournamentIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7e2326",
  null
  
)

export default component.exports